<template>
    <div class="container reporte-ecp-container">
        <b-row>
            <b-container>
                <h3 class="text-center py-2">
                    <b><i>{{ labels.title }}</i></b>
                </h3>

                <h5 class="text-center py-2">
                    <!-- FILTROS -->
                    <b-row class="mb-4 justify-content-center align-items-end text-lg">
                        <b-col md="auto" class="text-center px-3">
                            <label class="d-block fw-bold fs-4 mb-3"><b>{{ labels.reporte }}</b></label>
                            <select v-model="codReporte" @change="f_actualiza_reporte()"
                                class="form-control form-control-lg w-auto mx-auto fs-5" style="min-width: 200px;">
                                <option value="">Seleccione...</option>
                                <option v-for="reporte in reportes" :key="reporte.codigo" :value="reporte.codigo">
                                    {{ reporte.codigo }} - {{ reporte.nombre }}
                                </option>
                            </select>
                        </b-col>

                        <b-col md="auto" class="text-center px-3">
                            <label class="d-block fw-bold fs-4 mb-3">
                                <b>{{ labels.vigencia }}</b>
                            </label>
                            <select v-model="selVigencia" @change="f_actualiza_vigencia()"
                                class="form-control form-control-lg w-auto mx-auto fs-5" style="min-width: 200px;">
                                <option value="">Seleccione...</option>
                                <option v-for="vigencia in listVigencia" :key="vigencia.vigencia"
                                    :value="vigencia.vigencia">
                                    {{ vigencia.vigencia }}
                                </option>
                            </select>
                        </b-col>

                        <b-col md="auto" class="text-center px-3">
                            <label class="d-block fw-bold fs-4 mb-3">
                                <b>{{ labels.grupo }}</b>
                            </label>
                            <select v-model="grupoId" @change="f_actualiza_grupo()"
                                class="form-control form-control-lg w-auto mx-auto fs-5" style="min-width: 200px;">
                                <option value="todos">Todos los grupos</option>
                                <option v-for="grupo in listGrupos" :key="'grupo-' + grupo.id" :value="grupo.id">
                                    {{ grupo.nombre }}
                                </option>
                            </select>
                        </b-col>

                        <b-col md="auto" class="text-center px-3">
                            <label class="d-block fw-bold fs-4 mb-3">
                                <b>{{ labels.company }}</b>
                            </label>
                            <select v-model="companyId" @change="f_actualiza_compania()"
                                class="form-control form-control-lg w-auto mx-auto fs-5"
                                style="min-width: 180px; max-width: 250px;">
                                <option value="">Seleccione...</option>
                                <option v-for="company in filteredCompanies" :key="company.id" :value="company.id">
                                    {{ company.acronym ? company.acronym + ' ' : '' }}{{ company.nombre }}
                                </option>
                            </select>
                        </b-col>
                    </b-row>

                    <!-- BOTÓN -->
                    <b-row class="mb-4 justify-content-center align-items-center">
                        <b-col md="auto" class="text-center">
                            <b-button variant="primary" @click="consultaNiveles" :disabled="!isFormValid"
                                class="btn-lg px-5 mx-2 fs-5">
                                <b><i>{{ labels.consultar }}</i></b>
                            </b-button>
                        </b-col>
                    </b-row>
                </h5>
            </b-container>
        </b-row>

  

    <div class="row mt-3" v-if="showNiveles">
      <div class="col-md-3">
        <NivelUno @envLevUno="recNivUno" :isVigenciaBloqueada="isVigenciaBloqueada"/>
      </div>
      <div class="col-md-3">
        <NivelDos @envLevDos="recNivDos" v-if="showDos == true" :infoNivDos="listLevDos" :nivelUnoSel="nivUnoSelected" :isVigenciaBloqueada="isVigenciaBloqueada" />
      </div>
      <div class="col-md-3">
        <NivelTres @envLevTresNull="recNivTresNull"  @envLevTres="recNivTres" @abreNivelCuatro="abreNivelCuatro" v-if="showTres == true" :infoNivTres="listLevTres" :nivelDosSel="nivDosSelected" :nivelUnoSel="nivUnoSelected" :isVigenciaBloqueada="isVigenciaBloqueada" />
      </div>
      <div class="col-md-3">
        <NivelCuatro @envLevCuatro="recNivCuatro" v-if="showCuatro == true" :infoNivCuatro="listLevCuatro" :nivelTresSel="nivTresSelected" :nivelDosSel="nivDosSelected" :nivelUnoSel="nivUnoSelected" :isVigenciaBloqueada="isVigenciaBloqueada" />
      </div>
    </div>
    <div class="row mt-3">
      <NivelCuatroDetalle v-if="showCuatroDet == true" :codReporte="codReporte" :infoNivCuatroDetal="listLevCuatroDet" :infoNivelSelected="nivelSelect" :infoVigenCompa="dataVigenCompa"/>
    </div>
  </div>
</template>

<script>
import NivelUno from './NivelUno.vue'
import NivelDos from './NivelDos.vue'
import NivelTres from './NivelTres.vue'
import NivelCuatro from './NivelCuatro.vue'
import NivelCuatroDetalle from './NivelCuatroDetalle.vue'
import Nivel from '../../services/Nivel'
import PlanCuentas from "../../services/PlanCuentas"
import Company from "../../services/Company"
import Balance from "../../services/BalanceNiif"
import Grupo from "../../services/Grupo"

export default {
    name:"Niveles",
    data: () => ({
        vigencia_anterior : '',
        compania_anterior : '',
        codReporteAnterior : '',
        grupoId: 'todos',
        listGrupos: [],
        filteredCompanies: [],
        showDos: false,
        showTres: false,
        showCuatro: false,
        showCuatroDet: false,
        showNiveles: false,
        titleUno : "",
        titleDos : "",
        titleTres: "",
        levDosSel: "",
        listLevDos : [],
        listLevTres : [],
        listLevCuatro : [],
        listLevCuatroDet : [],
        selVigencia : "",
        codReporte : "",
        companyId : "",
        listVigencia : [],
        listCompany : [],
        companiaUsuario : [],
        reportes : [],
        nivelSelect: {},
        dataVigenCompa: {},
        nivUnoSelected : "",
        nivDosSelected : "",
        nivTresSelected : "",
    }),
    components:{
        NivelUno,
        NivelDos,
        NivelTres,
        NivelCuatro,
        NivelCuatroDetalle
    },
    computed:{
        labels(){
            if (this.$store.state._language == "es-ES") {
                return {
                    title: this.$route.params.tipo == 'directo' ? "Niveles: Flujo De Efectivo - Metodo Directo" : "Niveles: Flujo De Efectivo - Metodo Indirecto",
                    vigencia: "Vigencia:",
                    company: "Compañía:",
                    reporte: "Reporte:",
                    grupo: "Grupo:",
                    allGroups: "Todos los grupos",
                    consultar: "Consultar"
                }
            }else{
                return {
                    title: this.$route.params.tipo == 'directo' ? "Levels: Cash Flow - Direct Method" : "Levels: Cash Flow - Indirect Method",
                    vigencia: "Validity:",
                    company: "Company:",
                    reporte: "Report:",
                    grupo: "Group:",
                    allGroups: "All groups",
                    consultar: "Consult"
                }
            }
        },
        isFormValid() {
            return this.codReporte && this.selVigencia && this.companyId;
        },
        isVigenciaBloqueada() {
            return this.selVigencia ? !this.$store.getters.isPeriodoEnabled(this.selVigencia) : false
        }
    },
    methods:{
        goToRoute(page){
            this.$router.push({path: page })
        },
        
        f_actualiza_compania() {
            if (this.compania_anterior != this.companyId) {
                this.resetNiveles()
                this.compania_anterior = this.companyId
            }
        },
        
        f_actualiza_reporte() {
            if (this.codReporteAnterior != this.codReporte) {
                this.resetNiveles()
                this.codReporteAnterior = this.codReporte
            }
        },
        
        f_actualiza_vigencia() {
            if (this.vigencia_anterior != this.selVigencia) {
                this.resetNiveles()
                this.vigencia_anterior = this.selVigencia
            }
            if (this.isVigenciaBloqueada) {
                this.$toast.error('La vigencia seleccionada está deshabilitada para crear o editar.')
            }
        },
        
        f_actualiza_grupo() {
            this.filtrarCompaniesPorGrupo()
            this.resetNiveles()
            this.companyId = ""
        },
        
        resetNiveles() {
            this.showNiveles = false
            this.showDos = false
            this.showTres = false
            this.showCuatro = false
            this.showCuatroDet = false
            this.listLevCuatroDet = []
            this.nivUnoSelected = ""
            this.nivDosSelected = ""
            this.nivTresSelected = ""
            this.titleUno = ""
            this.titleDos = ""
            this.titleTres = ""
        },
        
        filtrarCompaniesPorGrupo() {
            this.companyId = ''
            this.resetNiveles()

            if (this.grupoId === 'todos' || !this.grupoId) {
                this.filteredCompanies = [...this.listCompany]
            } else {
                const grupoIdStr = this.grupoId.toString()
                this.filteredCompanies = this.listCompany.filter(company => {
                    if (!company.id_grupos) return false
                    const gruposCompania = company.id_grupos.split(',').map(id => id.trim())
                    return gruposCompania.includes(grupoIdStr)
                })
            }
        },
        
        consultaNiveles(){
            if(this.selVigencia != "" && this.companyId != "" && this.codReporte != ""){
                this.showNiveles = true

                this.dataVigenCompa = {
                    "vigencia" : this.selVigencia,
                    "compania" : this.companyId,
                    "codReporte" : this.codReporte,
                }
            
            }else{
                this.$toast.error("Diligenciar los campos: reporte, vigencia y compañía")
            }
        },
        
        recNivUno(nivUno){
            this.titleUno = nivUno
            this.nivUnoSelected = nivUno
            this.nivDosSelected = ""
            this.nivTresSelected = ""
            this.showDos = false
            this.showTres = false
            this.showCuatro = false
            this.showCuatroDet = false
            this.listLevCuatroDet = []
            this.titleDos = ""
            this.titleTres = ""
            if (nivUno != ""){
                this.showDos = true
                if(this.$route.params.tipo == 'directo'){
                    Nivel.getLevTwoByLevOne(nivUno)
                    .then((res) => {
                        this.listLevDos = res.data.nivelDosEfe
                    })
                    .catch((err) => {
                        console.log(err)
                    })
                }else{
                    Nivel.getLevTwoByLevOneInd(nivUno)
                    .then((res) => {
                        this.listLevDos = res.data.nivelDosEfe
                    })
                    .catch((err) => {
                        console.log(err)
                    })
                }
            }
        },

        recNivDos(nivDos){
            this.titleDos = nivDos
            this.nivDosSelected = nivDos
            this.nivTresSelected = ""
            this.showTres = false
            this.showCuatro = false
            this.showCuatroDet = false
            this.titleTres = ""
            if (nivDos != ""){
                this.showTres = true
                if(this.$route.params.tipo == 'directo'){
                    Nivel.getLevThreeByLevOneLevTwo(this.titleUno,nivDos)
                    .then((res) => {
                        this.listLevTres = res.data.nivelTresEfe
                    })
                    .catch((err) => {
                        console.log(err)
                    })
                }else{
                    Nivel.getLevThreeByLevOneLevTwoInd(this.titleUno,nivDos)
                    .then((res) => {
                        this.listLevTres = res.data.nivelTresEfe
                    })
                    .catch((err) => {
                        console.log(err)
                    })
                }
            }
        },

        recNivTresNull(nivTres){
            if(nivTres == null){
                this.showCuatro = true

                if(this.$route.params.tipo == 'directo'){
                    Nivel.getLevFourByLevOneLevTwoLevThreeNull(this.titleUno,this.titleDos,nivTres)
                    .then((res) => {
                        this.listLevCuatro = res.data.nivelCuatroEfe
                    })
                    .catch((err) => {
                        console.log(err)
                    })
                }else{
                    Nivel.getLevFourByLevOneLevTwoLevThreeNullInd(this.titleUno,this.titleDos,nivTres)
                    .then((res) => {
                        this.listLevCuatro = res.data.nivelCuatroEfe
                    })
                    .catch((err) => {
                        console.log(err)
                    })
                }
            }else{
                this.showCuatro = false
                this.showCuatroDet = false
            }
        },

        recNivTres(nivTres){
            this.titleTres = nivTres
            this.nivTresSelected = nivTres
            if(nivTres != ""){
                this.showCuatro = true

                if(this.$route.params.tipo == 'directo'){
                    Nivel.getLevFourByLevOneLevTwoLevThree(this.titleUno,this.titleDos,nivTres)
                    .then((res) => {
                        this.listLevCuatro = res.data.nivelCuatroEfe
                    })
                    .catch((err) => {
                        console.log(err)
                    })
                }else{
                    Nivel.getLevFourByLevOneLevTwoLevThreeInd(this.titleUno,this.titleDos,nivTres)
                    .then((res) => {
                        this.listLevCuatro = res.data.nivelCuatroEfe
                    })
                    .catch((err) => {
                        console.log(err)
                    })
                }
            }else{
                this.showCuatro = false
                this.showCuatroDet = false
            }
        },

        abreNivelCuatro(opcion){
            this.showCuatro = opcion
        },
        
        recNivCuatro(nivCuatro){
            this.nivelSelect = {
                "nivelUno" : this.titleUno, 
                "nivelDos" : this.titleDos, 
                "nivelTres" : this.titleTres, 
                "nivelCuatro" : nivCuatro
            }
            this.listLevCuatroDet = []
            if(nivCuatro != "" && this.titleTres != ""){
                this.showCuatroDet = true

                if(this.$route.params.tipo == 'directo'){
                    Nivel.getLevDetalFourByLevOneLevTwoLevThreeLevFour(this.titleUno,this.titleDos,this.titleTres,nivCuatro,this.selVigencia,this.companyId,this.codReporte)
                    .then((res) => {
                        this.listLevCuatroDet = res.data.nivCuatroEfeDet
                    })
                    .catch((err) => {
                        if(err.response.status == 404){
                            this.$toast.error("No hay cuentas para este nivel")
                        }
                    })
                }else{
                    Nivel.getLevDetalFourByLevOneLevTwoLevThreeLevFourInd(this.titleUno,this.titleDos,this.titleTres,nivCuatro,this.selVigencia,this.companyId,this.codReporte)
                    .then((res) => {
                        this.listLevCuatroDet = res.data.nivCuatroEfeDet
                    })
                    .catch((err) => {
                        if(err.response.status == 404){
                            this.$toast.error("No hay cuentas para este nivel")
                        }
                    })
                }
            }else{
                if(this.$route.params.tipo == 'directo'){
                    Nivel.getLevDetalFourByLevOneLevTwoLevThreeNullLevFour(this.titleUno,this.titleDos,null,nivCuatro,this.selVigencia,this.companyId,this.codReporte)
                    .then((res) => {
                        this.listLevCuatroDet = res.data.nivCuatroEfeDet
                        this.showCuatroDet = true
                    })
                    .catch((err) => {
                        if(err.response.status == 404){
                            this.$toast.error("No hay cuentas para este nivel")
                            this.showCuatroDet = true
                        }
                    })
                }else{
                    Nivel.getLevDetalFourByLevOneLevTwoLevThreeNullLevFourInd(this.titleUno,this.titleDos,null,nivCuatro,this.selVigencia,this.companyId,this.codReporte)
                    .then((res) => {
                        this.listLevCuatroDet = res.data.nivCuatroEfeDet
                        this.showCuatroDet = true
                    })
                    .catch((err) => {
                        if(err.response.status == 404){
                            this.$toast.error("No hay cuentas para este nivel")
                            this.showCuatroDet = true
                        }
                    })
                }
            }
        }
    },
    mounted(){
        Balance.leaCompaniaUsuario()
        .then ((result) => {
            this.companiaUsuario = result.data.companiaUsuario
        })
        
        PlanCuentas.getVigenciaPlancuentas()
        .then((result) => {
            this.listVigencia = result.data.getVigencia
        })
        .catch((err) => {
            console.log(err)
        })

        Company.getAllCompanies()
        .then((result) => {
            this.listCompany = result.data.companies
            let v_companias = []
            result.data.companies.forEach((element) => {
                const v_usuario = this.companiaUsuario.find((r_usuario) => 
                    r_usuario.id_usuario == this.$store.state.userId &&
                    r_usuario.id_compania == element.id)
                if (this.$store.state.userRole==1 || v_usuario) {
                    v_companias.push(element)
                }
            })
            this.listCompany = v_companias
            this.filteredCompanies = [...v_companias]
        })
        .catch((err) => {
            console.log(err)
        })
        
        Balance.getReportes()
        .then ((result) => {
            this.reportes = result.data.reportes
        })
        .catch(() => {
            this.error = true
        })
        
        Grupo.getAllGrupos()
        .then((result) => {
            this.listGrupos = result.data.grupos || []
        })
        .catch((err) => {
            console.log(err)
        })
    },
    watch:{
        titleUno(valNew,valOld){
            if(valOld != ""){
                this.showTres = false
                this.showCuatro = false
                this.showCuatroDet = false
                this.titleDos = ""
                this.listLevDos = []
                this.titleTres = ""
            }
        },

        titleDos(valNew,valOld){
            if(valOld != ""){
                this.showCuatro = false
                this.showCuatroDet = false
                this.listLevTres = []
                this.titleTres = ""
            }
        },

        titleTres(valNew,valOld){
            if(valOld != ""){
                this.showCuatroDet = false
                this.listLevCuatro = []
            }
        }
    }
}
</script>

<style scoped>

.reporte-ecp-container {
  margin-top: 20px;
}

.fs-5 {
  font-size: 1.25rem !important;
}

.fs-4 {
  font-size: 1.5rem !important;
  font-weight: 700 !important;
}

.mb-3 {
  margin-bottom: 1rem !important;
}

.form-control-lg {
  font-size: 1.25rem;
  padding: 0.5rem 1rem;
  height: auto;
  line-height: 1.5;
  border-radius: 0.3rem;
}

.btn-lg {
  padding: 0.5rem 1rem;
  font-size: 1.25rem;
  line-height: 1.5;
  border-radius: 0.3rem;
}

.px-5 {
  padding-left: 3rem !important;
  padding-right: 3rem !important;
}

.mx-2 {
  margin-left: 0.5rem !important;
  margin-right: 0.5rem !important;
}

.px-3 {
  padding-left: 1rem !important;
  padding-right: 1rem !important;
}

.py-2 {
  padding-top: 0.5rem !important;
  padding-bottom: 0.5rem !important;
}

.text-center {
  text-align: center;
}


.d-block {
  display: block;
}

.w-auto {
  width: auto !important;
}

.mx-auto {
  margin-left: auto !important;
  margin-right: auto !important;
}

.justify-content-center {
  justify-content: center !important;
}

.align-items-end {
  align-items: flex-end !important;
}


.mt-3 {
  margin-top: 1rem !important;
}

.mt-5 {
  margin-top: 3rem !important;
}

.row {
  display: flex;
  flex-wrap: wrap;
  margin-right: -15px;
  margin-left: -15px;
}

.col-md-3 {
  position: relative;
  width: 100%;
  padding-right: 15px;
  padding-left: 15px;
}

@media (min-width: 768px) {
  .col-md-3 {
    flex: 0 0 25%;
    max-width: 25%;
  }
  .col-md-auto {
    flex: 0 0 auto;
    width: auto;
    max-width: 100%;
  }
}

/* Responsive */
@media (max-width: 768px) {
  .fs-4 {
    font-size: 1.5rem !important;
  }
  
  .fs-5 {
    font-size: 1rem !important;
  }
  
  .form-control-lg {
    font-size: 1rem;
    min-width: 150px !important;
  }
  
  .btn-lg {
    font-size: 1rem;
    padding: 0.4rem 0.8rem;
  }
  
  .px-3 {
    margin-bottom: 1rem;
  }
}


/* Estilo para los selects cuando están enfocados */
.form-control:focus {
  border-color: #2e507a;
  box-shadow: 0 0 0 0.2rem rgba(46, 80, 122, 0.25);
}

/* Estilo para las etiquetas */
label b {
  color: #2c3e50;
}

/* Container principal */
.container {
  width: 100%;
  padding-right: 15px;
  padding-left: 15px;
  margin-right: auto;
  margin-left: auto;
}

@media (min-width: 1200px) {
  .container {
    max-width: 1140px;
  }
}

.filtro-label {
    font-size: 1.5rem !important;
    font-weight: 700 !important;
}


</style>
<style src="../main.css" scoped></style>
